import {React, Switch, Route} from 'external/react'
import {GradeBook, StudentGrades, RedirectToFirstGroup} from 'components/gradebook'
import './gradebook.styl'

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}'
const gradebookPath = '/:languageId/:role/:page(gradebook)'

export default function GradebookPage() {
  return (
     <Switch>
      <Route exact path={gradebookPath} component={RedirectToFirstGroup} />
      <Route exact path={`${gradebookPath}/:groupId(${UUID})`} component={GradeBook} />
      <Route exact path={`${gradebookPath}/:groupId(${UUID})/:studentId(${UUID})`} component={StudentGrades} />
    </Switch>
  )
}
